import styled from "styled-components";
import { Form } from "formik";
import { Modal } from "react-bootstrap";

export const ModalStyle = styled(Modal)`
  .modal-content {
    padding: 26px;
    border-radius: 10px;
    max-width: 500px;
    width: 100%;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  span {
    color: ${({ theme }) => theme.colors.blue};
    font-family: "Mangueira Bold";
    font-size: 1.125rem;
  }

  svg {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.blue};
  }
`;

export const Title = styled.h1`
  margin: 0;
  color: #074f8c;
  font-size: 1.25rem;
  font-weight: 400;
`;

export const Container = styled.div`
  margin-top: 20px;
  h1 {
    margin-bottom: 20px;
  }
`;

export const Text = styled.p`
  color: ${({ theme }) => theme.colors.gray};
  font-size: 0.9375rem;
  font-weight: 400;
  margin-bottom: 20px;
`;

export const Alert = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  ul {
    padding-inline-start: 1rem;
    margin-bottom: 0;
  }
`;

export const FormContainer = styled(Form)`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const FieldContainer = styled.div`
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ContainerButtons = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  margin-top: 30px;
`;
